import { inject, Injectable } from '@angular/core';

import { _ListService } from 'src/app/infrastructure/services/list-services/_list.service';
import { IImageListDto } from 'src/assets/common/models/image-list-dto.g';
import { IImageListData, ImageListData, imageListData } from '../models/image-list-data';
import { tabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { LoadingService } from 'src/app/infrastructure/services/loading-services/_loading.service';
import { TabListService } from '../../shared/central-page/services/tab-list.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable()
export class ImageListService
    extends _ListService<IImageListDto, IImageListData>
{
    protected override readonly _loadingService = injectRequired(LoadingService);
    protected override readonly _tabListService = inject(TabListService, { optional: true });

    override listActive$ = this._listActive$;
    override hasDeletedList$$ = this._hasDeletedList$$;
    override hasInactiveList$$ = this._hasInactiveList$$;
    override listActive$$ = this._listActive$$;
    override listAll$$ = this._listAll$$;
    override listDeleted$$ = this._listDeleted$$;
    override listDeletedAll$$ = this._listDeletedAll$$;
    override listInactive$$ = this._listInactive$$;

    override listName = tabName.images;

    override list_refresh$ = this._list_refresh$;

    override list_load$ = this._list_load$;

    override listData_load(listDto: IImageListDto): IImageListData | null {
        return ImageListData.create(listDto);
    }

    // Schrijf een nieuwe volgorde van de actieve foto's terug (drag-reorder in de grid). De
    // inactieve/verwijderde items blijven achteraan staan zodat ze niet uit listAll verdwijnen.
    list_reorder(orderedActive: IImageListData[]): void {
        const __inactive = this._listAll$$().filter(item => item[imageListData.inactive]);
        this._listAll$$.set([...orderedActive, ...__inactive]);
    }
}
